import Editor from '@toast-ui/editor';
import colorSyntax from '@toast-ui/editor-plugin-color-syntax';
import codeSyntaxHighlight
    from '@toast-ui/editor-plugin-code-syntax-highlight/dist/toastui-editor-plugin-code-syntax-highlight-all.js';
import Prism from 'prismjs';

export function init(parent) {
    parent.querySelectorAll('.toastui-editor-base:not([data-toastui-loaded="true"])').forEach((el) => {
        const area = el.previousElementSibling;
        el.setAttribute('data-toastui-loaded', true);
        el.querySelectorAll('*').forEach((elem) => elem.remove());
        area.removeAttribute('required');

        const editor = new Editor({
            el: el,
            initialEditType: 'wysiwyg',
            theme: 'dark',
            plugins: [colorSyntax, [codeSyntaxHighlight, {highlighter: Prism}]],
            initialValue: area.value,
            height: '500px',
            autofocus: false
        });

        editor.addHook('change', () => {
            area.value = editor.getMarkdown();
        });
    });
}